import { apiClient } from '@/shared/api';
import {
  RenessansDialogResultsParams,
  RenessansDialogResultsResponse,
  RenessansOperatorsParams,
  RenessansOperatorsResponse,
  RenessansSummaryParams,
  RenessansSummaryResponse,
} from './types';

/**
 * GET /dashboard/renessans-summary — KPI и временные ряды дашборда Ренессанс.
 */
export const fetchRenessansSummary = async (params?: RenessansSummaryParams): Promise<RenessansSummaryResponse> => {
  const { data } = await apiClient.get<RenessansSummaryResponse>('/dashboard/renessans-summary', { params });
  return data;
};

/**
 * GET /dashboard/renessans-operators — агрегация по операторам или по группам операторов.
 */
export const fetchRenessansOperators = async (
  params?: RenessansOperatorsParams,
): Promise<RenessansOperatorsResponse> => {
  const { data } = await apiClient.get<RenessansOperatorsResponse>('/dashboard/renessans-operators', { params });
  return data;
};

/**
 * GET /dashboard/renessans-dialog-results — распределение по `policy[*].terminationStatus`.
 * Ответ — `{ value, percent }` для каждого непустого значения, отсортировано по `percent` убыванию.
 */
export const fetchRenessansDialogResults = async (
  params?: RenessansDialogResultsParams,
): Promise<RenessansDialogResultsResponse> => {
  const { data } = await apiClient.get<RenessansDialogResultsResponse>('/dashboard/renessans-dialog-results', {
    params,
  });
  return data;
};
